(function($, undefined) {
    var regex = /<\/?[^>]+>/gi;
    
    $.fn.stripTags = function() {
        var html = this.html();
        var strippedHtml = html.replace(regex, '');
        return strippedHtml;
    };

    $.fn.stripTagsFromValue = function() {
        var text = this.val();
        var strippedHtml = text.replace(regex, '');
        return strippedHtml;
    };
})(jQuery);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.JQuery.stripTags.js